(function (aimi_post_api, $, app, undefined) {

  app.apis['post'] = function () {
    return {
      'stat': function (id) {
        return app.getRequest(`/api/post/stats/${id}`, {}, function () {
        }, function (response) {
          console.log(response);
        });
      },
      'history': function (id) {
        return app.getRequest(`/api/post/log/${id}`, {}, function () {
        }, function () {
        });
      },
      'templates' : function (id, templateIds) {
        return app.getRequest(`/api/post/templates/${id}?ids=${templateIds}`, {}, function () {
        }, function () {
        });
      },
      'svg' : function (id, requestData) {
        return app.putRequest(`/api/post/svg/${id}`, requestData, function () {} , function () {
        });
      },
      retry: function(requestData) {
        return app.putRequest(`/api/post/retry/${requestData.id}`, requestData, function () {
        }, function () {
        });
      },
      'delete': function (id) {
        return app.deleteRequest(`/api/post/post/${id}`, {}, function () {
        }, function () {
        });
      },
      update: function (requestData) {
        return app.putRequest(`/api/post/full/${requestData.id}`, requestData, function () {
        }, function () {
        });
      },
      swap: function(id, replacementId) {
        let requestData  = {
          old: id,
          new: replacementId
        };

        return app.putRequest(`/api/post/swap/${id}`, requestData, function () {
        }, function () {
        });
      },
      schedule : function (ids) {
        return app.postRequest(`/api/post/schedule`, ids, function () {
        }, function () {
        });
      },
      unschedule : function (ids) {
        return app.deleteRequest(`/api/post/schedule`, ids, function () {
        }, function () {
        });
      },
      approveLog: function (id) {
        return app.getRequest(`/api/post/approve-log/${id}`, {}, function () {
        }, function () {
        });
      }

    }
  }()

}(window.aimi_post_api = window.aimi_post_api || {}, jQuery, PreBuilt));